<template>
	<div v-loading.fullscreen.lock="homeLoading" element-loading-text="页面载入……" element-loading-background="#ffffff">
	<div id="appbox" v-show="!homeLoading">
		
		
		<div class="top_heard"  >
			<div class="top_tab_box">
				
				<div class="top_banner">
					<el-carousel ref="carousel" :interval="3000"  height="100vh" @change="checklunbo">
						<!-- :interval="4000" -->
					  <!-- <el-carousel-item v-for="(item, key) in platelist" :key="key" >
					    <h3>
							<div style="position: relative;">
								<img :src="item.thumb"  style="width: 100%;height: 100vh;" alt="" @click="gomodules(item.link)">
								<div class="text" style="position: absolute; left: 60px;top: 100px;font-size: 40px;color: #fff;">银色冰雪</div>
							</div>
							
						</h3>
					  </el-carousel-item> -->
					    <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图banner.jpg"  style="width: 100%;height: 100vh;object-fit: cover;" alt="" >
							<!-- <video class="bg-video" autoplay loop muted style="width: 100%;height: 100vh; object-fit: fill;">
    								<source src="http://1500006319.vod2.myqcloud.com/6c9ac7fbvodcq1500006319/bf85e8681397757897663925867/8lzITFpXAYQA.mp4" type="video/mp4" >
							</video> -->
							
								<!-- <div class="enter" style="position: absolute; left: 150px;top: 320px;font-size: 20px;color: #9c9c9c;">点击进入</div> -->
								<img src="../../../static/img/rightbanner.png" alt="" style="position: absolute;top: 12px;right: 40px;width: 450px;height: 100px;">
								<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 20px;left: 40px;width: 300px;height: 98px;object-fit: contain;">
							</div>
							
						</h3>
					  </el-carousel-item>
					  <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图1.jpg"  style="width: 100%;height: 100vh;" alt="" >
							<!-- <video class="bg-video" autoplay loop muted style="width: 100%;height: 100vh; object-fit: fill;">
    								<source src="http://1500006319.vod2.myqcloud.com/6c9ac7fbvodcq1500006319/bf85e8681397757897663925867/8lzITFpXAYQA.mp4" type="video/mp4" >
							</video> -->
								<div v-if="lunbo" class="size-color0 start-color">
									<div class="text" style="position: absolute; left: 150px;top: 250px;font-size: 58px;">三江口-特色基地</div>
								<!-- <div class="text" style="position: absolute; left: 150px;top: 320px;font-size: 40px;">SILVER - Snow and Ice Study Tour</div> -->
								<div class="text" style="position: absolute; left: 150px;top: 370px;font-size: 50px;">———</div>
								</div>
								<!-- <div class="enter" style="position: absolute; left: 150px;top: 320px;font-size: 20px;color: #9c9c9c;">点击进入</div> -->
								<img src="../../../static/img/rightbanner.png" alt="" style="position: absolute;top: 12px;right: 40px;width: 450px;height: 100px;">
								<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 20px;left: 40px;width: 300px;height: 98px;">
							</div>
							
						</h3>
					  </el-carousel-item>
					  <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图2.jpg"  style="width: 100%;height: 100vh;" alt="" >
								<div v-if="lunbo" class="size-color1 start-color">
									<div class="text" style="position: absolute; left: 150px;top: 250px;font-size: 58px;">天骄草原-特色基地</div>
								<!-- <div class="text" style="position: absolute; left: 150px;top: 320px;font-size: 40px;">GREEN - Ecological Civilization</div> -->
								<div class="text" style="position: absolute; left: 150px;top: 370px;font-size: 50px;">———</div>
								</div>
								<img src="../../../static/img/rightbanner.png" alt="" style="position: absolute;top: 12px;right: 40px;width: 450px;height: 100px;">
								<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 20px;left: 40px;width: 300px;height: 98px;object-fit: contain;">
							</div>
							
						</h3>
					  </el-carousel-item>
					  <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图3.jpg"  style="width: 100%;height: 100vh;" alt="" >
								<div v-if="lunbo" class="size-color2 start-color">
									<div class="text" style="position: absolute; left: 150px;top: 250px;font-size: 58px;">亭子码头-特色基地</div>
								<!-- <div class="text" style="position: absolute; left: 150px;top: 320px;font-size: 40px;">GOLDEN - Agricultural Practice</div> -->
								<div class="text" style="position: absolute; left: 150px;top: 370px;font-size: 50px;">———</div>
								</div>
								<img src="../../../static/img/rightbanner.png" alt="" style="position: absolute;top: 12px;right: 40px;width: 450px;height: 100px;">
								<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 20px;left: 40px;width: 300px;height: 98px;object-fit: contain;">
							</div>
							
						</h3>
					  </el-carousel-item>
					  <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图四.jpg"  style="width: 100%;height: 100vh;" alt="" >
								<div v-if="lunbo" class="size-color3 start-color">
									<div class="text" style="position: absolute; left: 150px;top: 250px;font-size: 58px;">南宁剧场-特色基地</div>
								<!-- <div class="text" style="position: absolute; left: 150px;top: 320px;font-size: 40px;">RED - Genetic Inheritance</div> -->
								<div class="text" style="position: absolute; left: 150px;top: 370px;font-size: 50px;">———</div>
								</div>
								<img src="../../../static/img/rightbanner.png" alt="" style="position: absolute;top: 12px;right: 40px;width: 450px;height: 100px;">
								<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 20px;left: 40px;width: 300px;height: 98px;object-fit: contain;">
							</div>
							
						</h3>
					  </el-carousel-item>
					  <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图5.jpg"  style="width: 100%;height: 100vh;" alt="" >
								<div v-if="lunbo" class="size-color4 start-color">
									<div class="text" style="position: absolute; left: 150px;top: 250px;font-size: 58px;">老口枢纽-特色基地</div>
								<!-- <div class="text" style="position: absolute; left: 150px;top: 320px;font-size: 40px;">BLUE - High - tech</div> -->
								<div class="text" style="position: absolute; left: 150px;top: 370px;font-size: 50px;">———</div>
								</div>
								<img src="../../../static/img/rightbanner.png" alt="" style="position: absolute;top: 12px;right: 40px;width: 450px;height: 100px;">
								<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 20px;left: 40px;width: 300px;height: 98px;object-fit: contain;">
							</div>
							
						</h3>
					  </el-carousel-item>
					  <!-- <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp">
								<img src="https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20241113/c89519eab42a7b4a9216f5c3d97e2689.png"  style="width: 100%;height: 100vh;" alt="" >
								<div class="text" style="position: absolute; left: 150px;top: 180px;font-size: 55px;color: #fff;">银色-冰雪研学</div>
								<div class="text" style="position: absolute; left: 150px;top: 240px;font-size: 35px;color: #fff;">Silver - Snow and Ice Study Tour</div>
								<div class="text" style="position: absolute; left: 150px;top: 300px;font-size: 45px;color: #fff;">———</div>
								<img src="https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20241113/1594db6790c64287cfa37b692b31e94c.png" alt="" style="position: absolute;top: 20px;left: 40px;width: 280px;height: 120px;">
							</div>
							
						</h3>
					  </el-carousel-item> -->
					</el-carousel>
				</div>
			
				
			</div>
		</div>
	
		
	
		<!-- <div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
			
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
					<div class="bottom_logo" v-if="screenWidth>785"  >
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					
				</div>
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div> -->
		<!-- <div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;padding-top:20px;'" >
			
			<div class="row" :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'" >
				<div class="bottom_right"  abort="" style="margin: 0 auto;align-items: center;padding-top: 10px;">
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						版权所有：黑龙江省研学实践教育协会 
					</div>
					<div class="bottom_msg">
						指导单位：黑龙江省教育厅 
					</div>
					
				</div>
				
			</div>
		</div> -->
	</div>
	<MoveWindow/>
	</div>

</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getBanner, getWxLogin, getAclist, getNewslist, getCategory, getCamplist, getActivitylist, getPac, getCourselist, getPc, getNt, getTeacher, getAdvbanner, getPlate,getLinelist,getTraveler,getRegion,getexpert,getbottomnav,getsitelist} from '@/request/api'
import { Loading } from 'element-ui';
import MoveWindow from './moveWindow/MoveWindow.vue'
// import navTab from '../Navtab/navtab'
let _this=null
export default {
  name: "Home",
  components: { MoveWindow },
  data(){
	  return {
	    
			lunbo:true,
			title:'黑龙江智慧研学云平台',
			top_search_url:'/Siteall',
			modules:'',
			activeIndex2: '/Home',
			Travelerlist:[],
			platelist:[],
			vTabs:false,
			phoneboxshow:false,
			userInfo: {
			  username: "",
			  education_name: "",
			  role_level: ""
			},
			stitle:'',
			Site_url: 'http://www.wanjiaxiao.net/',
			manage_url:'/',
			vannavshow:false,
			value: '',
			newstypes:[],
			Camplist:[],
			newscategory_id:0,
			logintype:true,
			banner:[
			],
			homeLoading: true,
			newslist:[],
			regionlist:[],
			expertlist:[],
			aclist:[],
			lessonlist:[],
			categorytypes:[],
			linelist:[],
			lessoncategory_id:0,
			pcsetdata:{},
			ntlist:[],
			mentorlist:[],
			mentor_index:'',
			mentorindex:0,
			mentortotal:0,
			advbanner:[],
			bottomnav:[],
			swiperexpert:{
				loop: true,
				slidesPerview:'auto',
				loopedSlides:7,
				autoplay:true,
				freeMode:true,
				width:165, 
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
					clickable: true
				},
				on:{
					transitionStart(){ // 开始translate之前触发
						// 如果是第一张
						if(this.activeIndex == 0){
							this.setTranslate(0); // 设置位移为0
						}
					},
					click(e) {
						// 使用e.target事件代理获取点击的元素，通过data语法获取元素的属性值
						let id = e.target.dataset.id;
						console.log(e.target.dataset)
						_this.goexpert(id)
						// 这里的this指向轮播,所以我在外边声明了_this用来代表vue实例
						// _this.goInto(url); // 跳转到详情页
					}
				}
			},
			swiperOption:{
				loop: true,
				slidesPerview:'auto',
				loopedSlides:4,
				autoplay: true,
				width:225, 
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
					clickable: true
				},
				on:{
					transitionStart(){ // 开始translate之前触发
						// 如果是第一张
						if(this.activeIndex == 0){
							this.setTranslate(0); // 设置位移为0
						}
					},
					click(e) {
						// 使用e.target事件代理获取点击的元素，通过data语法获取元素的属性值
						let id = e.target.dataset.id;
						console.log(e.target.dataset)
						_this.gocamp(id)
						// 这里的this指向轮播,所以我在外边声明了_this用来代表vue实例
						// _this.goInto(url); // 跳转到详情页
					}
				}
				
			},
			//侧边栏
			 showQR:false,
			  showserviceQR:false,
			  showofficialQR:false,
			tops:false,
			heights:window.innerHeight,
			scrolltop:'',
			//屏幕宽高
			// 屏幕宽度
			screenWidth: window.innerWidth,
			top_bannerWidth:Math.round(window.innerWidth/3.42),
			// 屏幕高度
			screenHeight: window.innerHeight,
	      }
  },
  created() {
	 
	  _this =this
	  this.getpcset()
	   this.getsitelist()
	   setTimeout(() => {
	   		this.homeLoading = false
	   }, 1000)
  },
  computed: {
    displayedItems() {
      // 使用window.innerWidth来判断当前设备是移动端还是PC端
      return this.isMobile ? this.mentorlist.slice(0, 4) : this.mentorlist.slice(0, 3);
    },
    isMobile() {
      return window.innerWidth < 768; // 假设屏幕宽度小于768px时是移动端
    },
  },
  mounted() {
		this.isWorkClient()
	  const { code,state } = this.$route.query;
	  if(code){
		  console.log(111)
		  this.$router.push({
		    path: '/Login',
		    name: "/Login",
		    params: {
		      code,
			  state,
		    }
		  });
		  return
	  }
	  // 监听屏幕宽度和高度变化
	  // this.top_bannerWidth=window.innerWidth/3.42
	    window.addEventListener('resize', this.handleResize, true)
		
	//   this.getPlate()
	//   this.getRegion()
	//   this.getexpert()
	//   this.getinnovate()
	//   // this.getnewstypes()
    // this._getbanner() 
	// this.getnewstypes()
	// this._getCamplist()
	// this._getAclist()
	// this.getlessontypes()
	// this.getlinelist()
	// this.getmentor()
	// this.getTraveler()
	// this.getNt()
	// this.getAdvbanner()
	// this.getbottomnav()
	// this.handleResize()
	var token = localStorage.getItem('token')||''
	this.token=token
	// this.getlessonlist()
  window.addEventListener('scroll', this.scrollToTop)
  		
  },
   destroyed () {
          window.removeEventListener('scroll', this.scrollToTop)
    },
  // 销毁监听
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
	  isWorkClient() {
      var ua = navigator.userAgent.toLowerCase();
      var isWXWork = ua.match(/wxwork/i) == "wxwork";
      var isWeixin = !isWXWork && ua.match(/micromessenger/i) == "micromessenger";
      var isMobile = false;
      var isDesktop = false;
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
        isMobile = true;
		//  this.judge();
		this.$router.push({
			path:'/Mobile',
		  	name:'/Mobile',
		  	
		})
      } else {
        isDesktop = true;
		console.log("电脑环境")
      }
      if (isWeixin) {
      } else if (isDesktop) {
      } else if (isWXWork) {
        // 判断是否是企微环境
        return true;
      } else {
      }
      return false;
    },
    judge() {
      this.jump();
    },
    jump() {
     
        // 跳转小程序
        location.href = 'weixin://dl/business/?appid=wx0646f495e7cdeed5&path=pages/home/home';
      
    },

	checklunbo(){
		this.lunbo=false
		setTimeout(()=>{
			this.lunbo=true
		},100)
	},
	  getsitelist(){
	  		var list=this.Siteoptions
	  		getsitelist().then(res=>{
	  			for(var item of res.data.data){
	  				list.push({
	  					value:'http://www.wanjiaxiao.net/subsite/?region_type='+item.region_type,
	  					label:item.title
	  				})
	  			}
	  			this.Siteoptions=list
	  		})  
	  },
	  vanlinkgo(e){
		  console.log(e)
		  this.$router.push({
		    path: e.link,
		    name: e.link,
		    query: {
		    }
		  }); 
	  },
	  vannavmenushow(){
		this.vannavshow=false  
	  },
	  handleResize() {
		console.log("屏幕宽度")
		   this.top_bannerWidth = 0;
	    this.screenWidth = window.innerWidth;
		this.top_bannerWidth=window.innerWidth/3.42
		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
		if(this.screenWidth>785){
			console.log("大于的")
			this.mentorlist=this.mentorlist.slice(0, 3)
			console.log("人才",this.mentorlist.slice(0, 3))
		}

	    this.screenHeight = window.innerHeight;
	  },
	  manageurl(e){
		  console.log('Site',e)
		  if(e!='/'){
			   window.open(e) 
		  }
		this.manage_url='/'
		  // window.location.href = e;
		  
	  },
	  Siteurl(e){
	  		console.log('Site',e)  
	  		window.location.href = e;
	  },
	  logout(){
	  			  var that=this
	  			  this.$confirm('是否确认退出登录?', '提示', {
	  			  					confirmButtonText: '确定',
	  			  					cancelButtonText: '取消',
	  			  					type: 'warning'
	  			  }).then(() => {
	  						this.$alert("已退出登录", '', {
	  							confirmButtonText: '确认',
	  							callback: action => {
	  								localStorage.setItem('token', '')
	  								localStorage.setItem('refreshToken', '')
	  								 that.$router.go(0)
	  							}
	  						  });
	  			  }).catch(() => {
	  			  		 
	  			  });
	  },
	  showQRCode(){//显示二维码
	          this.showQR = true
	      },
	      hideQRCode(){//隐藏二维码
	          this.showQR = false
	      },
	      scrollToTop () {
	          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
	          this.scrolltop = scrollTop
	          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
	              this.tops = true
	          } else {
	              this.tops = false
	          }
	      },
	      gotop () {
	          let timer = setInterval(() => {
	              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
	              if (this.scrolltop === 0) {
	                  clearInterval(timer)
	              }
	          }, 15)
	      },
	  getbottomnav(){
		  var data={
			  page_index:1,
			  page_size:15,
			  flag:99
		  }
		getbottomnav(data).then(res=>{
			this.bottomnav=res.data.data.list
		})  
	  },
	  gobottomnav(type,link){
		  if(type==1){
			  this.$router.push({
			  	path:link
			  });
		  }else if(type==2){
			  window.location.href = link;
		  }
	  },
	  goexpertlist(){
		  this.$router.push({
		  	path:'/expertlist',
		  	name:'/expertlist',
		  	query: {
		  	}
		  });
	  },
	  goexpert(id){
		  this.$router.push({
		  	path:'/expertdetails',
		  	name:'expertdetails',
		  	query: {
		  		id: id
		  	}
		  });
	  },
	  camptypego(id){
		  console.log(id)
		  this.$router.push({
		    path: '/Camplist',
		    name: "/Camplist",
		    query: {
		      region_type: id,
		    }
		  });
	  },
	  getRegion(){
	  			var data={
					page_size:10,
				}
	  			getRegion(data).then(res=>{
	  				var regionlist=[]
					var pagesize=0
					for(var item of res.data.data){
						console.log('item',item)
						if(pagesize<8){
							regionlist.push(item)
							
						}
						pagesize+=1
					}
					this.regionlist=regionlist
	  			})
	  },
	  gocolumn(url){
		  this.$router.push({
		    path: url,
		    name: url,
		    query: {
		    }
		  }); 
	  },
	  gotopsearch(){
		  this.$router.push({
		    path: this.top_search_url,
		    name: this.top_search_url,
		    query: {
		      stitle: this.stitle,
		    }
		  }); 
	  },
	  goTraveler(id){
		 this.$router.push({
		   path: "/travelerdetails",
		   name: "travelerdetails",
		   query: {
		     id: id
		   }
		 }); 
	  },
	  gomentor(){
		  this.$router.push({
		    path: "/mentorlist",
		    name: "/mentorlist",
		  		  query: {
		  		  }
		  });
	  },
	  goTravelerlist(){
		  this.$router.push({
		    path: "/traveler",
		    name: "/traveler",
		  		  query: {
		  		  }
		  });
	  },
	  getTraveler(){
		  var data={
		  	isshow:1,
			page_index:1,
			page_size:3,
			modules:this.modules,
		  }  
		  getTraveler(data).then(res=>{
			  this.Travelerlist=res.data.data.list
		  	// this.platelist=res.data.data
		  })
	  },
	  showofficialQRCode(){
		 this.showofficialQR=true
	  },
	  hideofficialQRCode(){//隐藏二维码
	      this.showofficialQR = false
	  },
	  showserviceQRCode(){
	  			  this.showserviceQR=true
	  },
	  hideserviceQRCode(){//隐藏二维码
	      this.showserviceQR = false
	  },
	  showphonebox(){
		this.phoneboxshow=true  
	  },
	  closephonebox(){
		this.phoneboxshow=false  
	  },
	  goregister(e){
	  			  this.$router.push({
	  			    path: "/register",
	  			    name: "/register",
	  			  		  query: {
	  			  		  }
	  			  });
	  },
	   showstep(ind) {
	        this.$refs.carousel.setActiveItem(ind)
	      },
		  goplate(id){
			  this.modules=id
			  this._getbanner()
			  
			  this.getnewstypes()
			  this._getCamplist()
			  this._getAclist()
			  this.getlessontypes()
			  this.getlinelist()
			  this.getmentor()
			  this.getTraveler()
		  },
	  getPlate(){
		var data={
			flag:99
		}  
		getPlate(data).then(res=>{
			this.platelist=res.data.data
		})
	  },
	  getlinelist(){
		  var data={
			  page_index: 1,
			  page_size: 3,
			  modules:this.modules,
			  is_pc:1,
		  }
		  getLinelist(data).then(res=>{
		  	console.log(res.data)
		  	this.linelist=res.data.data.list
		  	// this.quicklist=res.data.data.list
		  }).catch(error => {
		  	console.error(error);
		  });
	  },
	  getAdvbanner(){
		var data={
			is_pc:2,
			flag:'A'
		}  
		getAdvbanner(data).then(res=>{
			console.log('getAdvbanner',res)
			this.advbanner=res.data.data
		})
	  },
	  changementor(e){
		console.log('1112',e)  
		this.mentorindex=e+1
		this.getmentor()
	  },
	  mentoropen(index){
		this.mentor_index=index  
	  },
	  relist(data){
		  const list = data.split(',');
		  return list
	  },
	  getmentor(){
		  var data={
			  page_index:1,
			  page_size:4,
			  modules:this.modules,
		  }
		  getTeacher(data).then(res=>{
			  this.mentorlist=res.data.data.list
			  console.log("人才接口",this.mentorlist)
			  this.handleResize()
		  })
		 

		  
	  },
	  getNt(){
		var data={
				flag:99
			}
		getNt(data).then(res=>{
			this.ntlist=res.data.data
		})  
	  },
	  getpcset(){
		var data={
				flag:99
			}
		getPc(data).then(res=>{
			this.pcsetdata=res.data.data
			document.title=res.data.data.title
		})  
	  },
	  golesson(e) {
	    this.$router.push({
	      path: "/CourseDetails",
	      name: "CourseDetails",
	      query: {
	        id: e
	      }
	    });
	  },
	  camptypetab(val){
		// this.lessoncategory_id=val
		this.getlessonlist()
	  },
	  getlessontypes(){
	  			var data={}
	  			getPac(data).then(res=>{
	  				console.log(res.data)
	  				this.categorytypes=res.data.data.cat
	  				// this.periodtypes=res.data.data.res
	  				// this.lessoncategory_id=res.data.data.cat[0].id
	  				this.getlessonlist()
	  			}).catch(error => {
	  			  console.error(error);
	  			});
	  },
	  getlessonlist(){
	  			var data={
	  				// type:this.camptype,
	  				category_id:this.lessoncategory_id,
	  				page_index: 1,
	  				page_size: 3,
					modules:this.modules,
	  			}  
	  			getCourselist(data).then(res=>{
	  				this.lessonlist=res.data.data.list
					// this.homeLoading = false
	  				// this.total=res.data.data.total
	  				// this.quicklist=res.data.data.list
	  			}).catch(error => {
	  				console.error(error);
	  			});
	  },
	  newshandleClick(e){
			console.log(e,this.category_id)
			this._getNewslist()
	  },
	  getnewstypes(){
		  var data={}
		  getCategory(data).then(res=>{
				  console.log(res.data)
				  var types=[
					{
					  id:'0',
					  icon:'',
					  title:'综合资讯'
					}
				  ]
				  for(var item of res.data.data){
					  types.push(item)
				  }
				  this.newscategory_id='0'
				  this.newstypes=types
				  this._getNewslist()
			}).catch(error => {
			  console.error(error);
			});
	  },
	  _getNewslist(){
		  var data={
			page_index:1,
			page_size:6,
			category_id:this.newscategory_id,
			modules:this.modules,
		  }
		getNewslist(data).then(res=>{
			console.log(res.data)
			this.newslist=res.data.data.list
		  }).catch(error => {
			  console.error(error);
			});
	  },
	  getexpert(){
		  var data={
			page_index:1,
			page_size:20,
			modules:this.modules,
			type:1,
		  }
		  getexpert(data).then(res=>{
		  				  console.log(res.data)
		  				  this.expertlist=res.data.data.list
						  if(this.expertlist.length<8){
							  this.swiperexpert.autoplay=false
						  }
		  }).catch(error => {
		  				  console.error(error);
		  			});
	  },
	  getinnovate(){
	  		  var data={
	  			page_index:1,
	  			page_size:3,
	  			modules:this.modules,
	  			type:2,
	  		  }
	  		  getexpert(data).then(res=>{
	  		  				  console.log(res.data)
	  		  				  this.innovatelist=res.data.data.list
	  						  // if(this.expertlist.length<8){
	  							 //  this.swiperexpert.autoplay=false
	  						  // }
	  		  }).catch(error => {
	  		  				  console.error(error);
	  		  			});
	  },
	  _getCamplist(){
		  var data={
			  page_index:1,
			  page_size:8,
			  modules:this.modules,
		  }
		  getCamplist(data).then(res=>{
				  console.log(res.data)
				  this.Camplist=res.data.data.list
		  }).catch(error => {
		  				  console.error(error);
		  			});
	  },
	  _getAclist(){
		  var data={
			  page_index:1,
			  page_size:3,
			  modules:this.modules,
		  }
		  getAclist(data).then(res=>{
		  			  console.log(res.data)
					  this.aclist=res.data.data.list
		  			  // this.banner=res.data.data
		  }).catch(error => {
				  console.error(error);
			});
	  },
	  _getColumn(){
		  getColumn().then(res=>{
		  			  console.log(res.data)
		  			  // this.banner=res.data.data
		  }).catch(error => {
		  			  console.error(error);
		  			});
	  },
	  _getbanner(){
		  // console.log(22233, getBanner())
			var data={
				is_pc:2,
				modules:this.modules,
				flag:99
			}
		  getBanner(data).then(res=>{
			  console.log(res.data)
			  this.banner=res.data.data
		  }).catch(error => {
			  console.error(error);
			});
	  },
	handleSelect(key, keyPath) {
		console.log(key, keyPath);
	},
	golist(e){
		this.$router.push({
		  path: "/"+e,
		  name:"/"+e,
			query: {
			}
		});
	},
	gontdetails(e){
		this.$router.push({
		  path: "/Ntdetails",
		  name: "Ntdetails",
		  query: {
		    id: e
		  }
		});
	},
    gonews(e){
		this.$router.push({
		  path: "/NewsDetails",
		  name: "NewsDetails",
		  query: {
		    id: e
		  }
		});
	},
	gocamp(e){
		// console.log(e)
		// this.$router.push({
		//   path: "/Courselist",
		//   name: "/Courselist",
		//   query: {
		//     category_id:2
		//   }
		// });
		this.$router.push({
		  path: "/Home1",
		  name: "/Home1",
		
		});
	},
	// gocamp(e){
	// 	// console.log(e)
	// 	this.$router.push({
	// 	  path: "/Camplist",
	// 	  name: "/Camplist",
	// 	  query: {
	// 	    tags_id: e,
	// 	  }
	// 	});
	// },
	goline(e){
		this.$router.push({
		  path: "/LineDetails",
		  name: "LineDetails",
		  query: {
		    id: e
		  }
		});
	},
	goactivity(e){
		this.$router.push({
		  path: "/Activitydetails",
		  name: "Activitydetails",
		  query: {
		    id: e
		  }
		});
	},
	gomodules(e){
		console.log("link");
		console.log(e);
		if(e){
			window.location.href = e;
			//this.$router.push(e);
		}
	},
  }
};
	
</script>

<style scoped lang="less">
.enter{
-webkit-animation: twinkling 1s infinite ease-in-out
}
.animated{
-webkit-animation-duration: 1s;
animation-duration: 1s;
-webkit-animation-fill-mode: both;
animation-fill-mode: both
}
@-webkit-keyframes twinkling{
0%{
opacity: 0.5;
}
100%{
opacity: 1;
}
}
@keyframes twinkling{
0%{
opacity: 0.5;
}
100%{
opacity: 1;
}
}
.el-button--success{
	color: #FE7C2B !important;
	border-color: #FE7C2B !important;
	background-color: #dceef8 !important;
}

	// @keyframes siz {
    //         from{transform: translateY(-100%);}
    //         to{transform: translateY(0);}
    //     }
 
    //     .text{
    //         overflow: hidden;
    //         white-space: pre-wrap;
    //         animation: siz 2s ease-in-out forwards;
			
    //     }
		.size-color{
			
		}
		.start-color{
			color: #fff;
		}
// 银色
.size-color0:hover{
	color: #efefef;
}
// 绿色：
.size-color1:hover{
	color: #6bffa6;
}
// 金色
.size-color2:hover{
	color: #ebda1c;
}
// 红色
.size-color3:hover{
	color: #ff2400;
}
// 蓝色
.size-color4:hover{
	color: #00fcff;
}
.top_banner{
	width: 100%;
	overflow-x: hidden;
	height: 100vh;
}
	.column_titleicon{
		width: 1180px;
		height: 60px;
	}
	.column_titleicon img{
		width: 100%;
		height: 100%;
	}
	
	body{
		background: #ffffff;
	}
	#appbox{
		background: #ffffff;
	}
	
	/* 图片轮播 */
	 .el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 150px;
	    margin: 0;
	  }
	  
	  .el-carousel__item:nth-child(2n) {
	     background-color: #99a9bf;
	  }
	  /deep/ .el-carousel__indicators {// 指示器
        // left: unset;
        // transform: unset;
		bottom: 20px;
        // right: 2%;
    }
	  
	  .el-carousel__item:nth-child(2n+1) {
	     background-color: #d3dce6;
	  }
	  @media only screen and (max-width: 768px){ /* 在小于等于768px的设备上执行该CSS代码 */
	  
	  	.el-tabs__item{
	  		font-size: 16px;
			padding: 0px;
	  	}
	
	  }

</style>